// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../node_modules/exports-loader/index.js?module.exports.toString()!../../../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../../../node_modules/postcss-loader/index.js??postcss!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--5-3!./ubiMenuItem.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../../../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/exports-loader/index.js?module.exports.toString()!../../../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../../../node_modules/postcss-loader/index.js??postcss!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--5-3!./ubiMenuItem.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/exports-loader/index.js?module.exports.toString()!../../../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../../../node_modules/postcss-loader/index.js??postcss!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--5-3!./ubiMenuItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/node_modules/style-loader!C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMenu/components/ubiMenuItem/ubiMenuItem.scss
// module id = ../../../../style-loader/index.js!../../../../../src/app/theme/components/ubiMenu/components/ubiMenuItem/ubiMenuItem.scss
// module chunks = main